import React, { cloneElement, useState } from "react";
import PercentageNumber from "../../../../components/UI/PercentageNumber";
import CurrencyNumber from "../../../../components/UI/CurrencyNumber";
import Button from "@material-ui/core/Button";
import Slider from "@material-ui/core/Slider";
import { Close } from "@material-ui/icons";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import { advisorConfigFields } from "../../../../utilities/constant";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import { Slide, withStyles } from "@material-ui/core";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Accordion from "@material-ui/core/Accordion";

const styles = (theme) => ({
  paper: {
    width: "100%",
    height: "80%",
  },
  modalCloseBtn: {
    position: "absolute",
    top: 10,
    right: 10,
  },
  slider: {
    maxWidth: "calc(60% - 54px)",
    marginLeft: "27px",
  },
  sliderLegend: {
    width: "60%",
    height: "10px",
    position: "absolute",
    top: 0,
    display: "flex",
    justifyContent: "space-between",
  },
  sliderLegendNum: {
    width: 70,
    fontSize: 14,
    textAlign: "center",
    "&:not(:first-child):not(:last-child)": {
      [theme.breakpoints.down("md")]: {
        display: "none",
      },
    },
  },
  expansionPanel: {
    background: "transparent",
    margin: 0,
  },
  expansionPanelDetails: {
    padding: "20px 0 10px",
    position: "relative",
  },
  expansionPanelExpanded: {
    margin: 0,
  },
  expansionPanelSummary: {
    padding: 0,
    minHeight: 1,
  },
  expansionPanelSummaryExpanded: {
    padding: 0,
    minHeight: 1,
  },
  line: {
    fontSize: 18,
    [theme.breakpoints.down("md")]: {
      fontSize: 14,
    },
    margin: 0,
    "& span": {
      color: theme.palette.primary.main,
    },
    "&.locked": {
      padding: `12px 0`,
      [theme.breakpoints.down("md")]: {
        fontSize: 14,
      },
      "& span": {
        color: theme.palette.grey[600],
      },
    },
  },
  row: {
    display: "block",
    flexWrap: "wrap",
  },
});

const HouseholdSettingModal = (props) => {
  const [open, setOpen] = useState(false);
  const [expanded, setExpanded] = useState("");

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const toggleExpansion = (name) => (event, expanded) => {
    setExpanded(expanded ? name : "");
  };

  const saveAdvisorConfig = () => {
    setOpen(false);
    props.saveAdvisorSettingToStore();
  };

  const {
    classes,
    advisorConfig,
    updateAdvisorSetting,
    dialogAnchorComponent,
  } = props;
  return (
    <React.Fragment>
      {cloneElement(dialogAnchorComponent, { onClick: handleOpenModal })}

      <Dialog
        open={open}
        TransitionComponent={Slide}
        TransitionProps={{ direction: "up" }}
        onClose={handleCloseModal}
        disableBackdropClick={true}
        disableEscapeKeyDown={true}
        aria-labelledby="household-settings-modal-title"
        maxWidth={"lg"}
        scroll={"paper"}
        classes={{ paper: classes.paper }}
      >
        <DialogTitle id="household-settings-modal-title">
          Household Settings
          <IconButton
            className={classes.modalCloseBtn}
            aria-label="Close"
            onClick={handleCloseModal}
          >
            <Close color="primary" />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          {advisorConfigFields.map((f, i) => {
            return (
              <div className={classes.row} key={i}>
                <Accordion
                  classes={{
                    root: classes.expansionPanel,
                    expanded: classes.expansionPanelExpanded,
                  }}
                  expanded={expanded === `config-${i}`}
                  onChange={toggleExpansion(`config-${i}`)}
                  // TransitionProps={{timeout: 0}}
                  elevation={0}
                  square={true}
                >
                  <AccordionSummary
                    classes={{
                      root: classes.expansionPanelSummary,
                      expanded: classes.expansionPanelSummaryExpanded,
                    }}
                  >
                    {f.valueFormat === "percentage" && (
                      <p
                        className={classes.line}
                        dangerouslySetInnerHTML={{
                          __html: f.line.replace(
                            "%",
                            `${(advisorConfig[f.fieldName] * 100).toFixed(2)}%`
                          ),
                        }}
                      />
                    )}
                    {f.valueFormat === "number" && (
                      <p
                        className={classes.line}
                        dangerouslySetInnerHTML={{
                          __html: f.line.replace(
                            "%",
                            advisorConfig[f.fieldName]
                          ),
                        }}
                      />
                    )}
                  </AccordionSummary>
                  <AccordionDetails className={classes.expansionPanelDetails}>
                    <div className={classes.sliderLegend}>
                      {f.valueFormat === "percentage" &&
                        Array(f.sliderParam.tickNumber)
                          .fill("")
                          .map((el, index) => {
                            return (
                              <div
                                className={classes.sliderLegendNum}
                                key={"el" + index}
                              >
                                <PercentageNumber
                                  value={
                                    ((f.sliderParam.max - f.sliderParam.min) /
                                      (f.sliderParam.tickNumber - 1)) *
                                      index +
                                    f.sliderParam.min
                                  }
                                />
                              </div>
                            );
                          })}
                      {f.valueFormat === "number" &&
                        Array(f.sliderParam.tickNumber)
                          .fill("")
                          .map((el, index) => {
                            return (
                              <div
                                className={classes.sliderLegendNum}
                                key={"el" + index}
                              >
                                {((f.sliderParam.max - f.sliderParam.min) /
                                  (f.sliderParam.tickNumber - 1)) *
                                  index +
                                  f.sliderParam.min}
                              </div>
                            );
                          })}
                    </div>
                    <Slider
                      className={classes.slider}
                      value={advisorConfig[f.fieldName]}
                      name={f.fieldName}
                      min={f.sliderParam.min}
                      max={f.sliderParam.max}
                      step={f.sliderParam.step}
                      onChange={updateAdvisorSetting(f.fieldName)}
                    />
                  </AccordionDetails>
                </Accordion>
              </div>
            );
          })}
          <div className={classes.row}>
            <p className={`${classes.line} locked`}>
              Social Security Wage Base{" "}
              <span>
                <CurrencyNumber value={advisorConfig.ssiBase} />
              </span>
            </p>
          </div>
          <div className={classes.row}>
            <p className={`${classes.line} locked`}>
              Social Security Max Benefit at FRA{" "}
              <span>
                <CurrencyNumber value={advisorConfig.ssiMaxBenefitAtFRA} />
              </span>
            </p>
          </div>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button
            variant="contained"
            color="primary"
            onClick={saveAdvisorConfig}
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};

export default withStyles(styles)(HouseholdSettingModal);



// WEBPACK FOOTER //
// ./src/containers/AddClient/components/HouseholdSettingModal/index.jsx